import React, { useState } from "react";

const GenericTableHeader = ({ columns, onResize }) => {
  const [resizingIndex, setResizingIndex] = useState(null);

  const handleMouseDown = (index, e) => {
    e.preventDefault();
    e.stopPropagation();
    setResizingIndex(index);
    onResize(index, e);

    const handleMouseUp = () => {
      setResizingIndex(null);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <>
      {columns?.map((col, index) => (
        <th key={col.id} style={{ width: col.width , maxWidth:col.width }}>
          <div className="custom-resizable-table-th-content">
            {col.label}
            <span
              className={`generic-table-header-resizer ${
                resizingIndex === index ? "visible" : ""
              }`}
              onMouseDown={(e) => handleMouseDown(index, e)}
            />
          </div>
        </th>
      ))}
    </>
  );
};

export default GenericTableHeader;
